import type * as React from 'react'
import { gridClasses } from '@mui/x-data-grid-premium'

const DATA_TITLE_ATTRIBUTE = 'data-original-title'

export const handleMouseLeave = (event: React.MouseEvent<HTMLElement>) => {
  const target = event.target as HTMLElement

  if (!target) {
    return
  }

  const currentTarget = target.closest?.(`.${gridClasses.cell}`)

  if (!currentTarget) {
    return
  }

  const previouslySavedTitle = currentTarget.getAttribute(DATA_TITLE_ATTRIBUTE)

  // early return if data-original-title is not set
  if (!previouslySavedTitle) {
    return
  }

  currentTarget.setAttribute('title', previouslySavedTitle)
  currentTarget.removeAttribute(DATA_TITLE_ATTRIBUTE)
}

export const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
  const target = event.target as HTMLElement

  if (!target) {
    return
  }
  const currentTarget = target.closest(`.${gridClasses.cell}`)

  if (!currentTarget) {
    return
  }

  const title = currentTarget.getAttribute('title')

  // early return if title is not set
  if (!title) {
    return
  }

  // replace title with data-original-title attribute
  currentTarget.removeAttribute('title')
  currentTarget.setAttribute(DATA_TITLE_ATTRIBUTE, title)
}
